const CONSULTATION_CARRIED_OUT_ELSEWHERE_THAN_CRDS = 'consultationCarriedOutElsewhereThanCRDS';

export default CONSULTATION_CARRIED_OUT_ELSEWHERE_THAN_CRDS;
